// extracted by mini-css-extract-plugin
module.exports = {"container":"nftSuccess_container__2K-dC","pic1":"nftSuccess_pic1__pnsRB","btn":"nftSuccess_btn__3oBxz","pic2":"nftSuccess_pic2__ORo9M"};